import { CloseOutlined } from '@mui/icons-material';
import { Box, Button, Divider, IconButton, Typography, useTheme } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import ComponentWrapper from 'ui/templates/ComponentWrapper/ComponentWrapper';

interface Props {
  handleClose: () => void;
  handleDeleteVisitor: () => void;
}

const DeleteVisitor: React.FC<React.PropsWithChildren<Props>> = ({ handleClose, handleDeleteVisitor }) => {
  const { translation } = useTranslation();
  const theme = useTheme();

  return (
    <Box
      id="delete-visitor-modal"
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: theme.custom.background.level3,
        border: `${theme.custom.borderWidth}px solid ${theme.custom.borderAndDivider.default}`,
        borderRadius: 1
      }}
    >
      <ComponentWrapper width="444px" flexDirection="column">
        <ComponentWrapper padding="16px 24px" justifyContent="space-between" alignItems="center">
          <Typography variant="h6" color="textPrimary">
            {translation.delete_user}
          </Typography>
          <IconButton onClick={handleClose} style={{ padding: '4px' }}>
            <CloseOutlined style={{ color: theme.custom.action.active }} />
          </IconButton>
        </ComponentWrapper>
        <Divider />
        <ComponentWrapper padding="16px 24px" flexDirection="column" gap="24px">
          <Typography variant="body2" color="textPrimary">
            {translation.delete_user_confirmation}
          </Typography>
        </ComponentWrapper>
        <Divider />
        <ComponentWrapper padding="8px" alignItems="center" justifyContent="end" gap="8px">
          <Button onClick={handleClose} size="medium" variant="text" style={{ color: theme.palette.text.primary }}>
            {translation.cancel}
          </Button>
          <Button
            onClick={handleDeleteVisitor}
            size="medium"
            color="error"
            variant="contained"
            id="delete-visitor-confirm-button"
          >
            {translation.delete_user}
          </Button>
        </ComponentWrapper>
      </ComponentWrapper>
    </Box>
  );
};

export default DeleteVisitor;
